import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=01b85638&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=01b85638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b85638",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b85638')) {
      api.createRecord('01b85638', component.options)
    } else {
      api.reload('01b85638', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=01b85638&scoped=true&", function () {
      api.rerender('01b85638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tt0K076N0Toz/JS/comp/SearchFilterTokens.vue"
export default component.exports